import PreviewDocRow from '@/components/PreviewDocRow';
import TechnicalDesignModal from '@/components/TechnicalDesignModal';
import UploadFileRow from '@/components/UploadFileRow';
import Button from '@/trio-ui/Button';
import * as Styles from './SubmittingTechnicalValidation.styles';

export type TechnicalDesignType = {
  title: string;
  prevTitle: string;
  body: string;
  prevBody: string;
  isOpen: boolean;
};

export type ProjectData = {
  id?: string;
  githubUrl: string;
  technicalDesign?: TechnicalDesignType;
  videoUrl: string;
};

export type SubmittingTechnicalValidationProps = {
  githubUrl: string;
  urlError: string;
  technicalDesign: TechnicalDesignType;
  videoFile: File | null;
  canSubmitProject: boolean;
  onSubmitProject: () => void;
  onAddGithubUrl: (link: string) => void;
  onToggleTechnicalDesignModal: () => void;
  onCloseTechnicalDesignModal: () => void;
  onSaveTechnicalDesign: () => void;
  onChangeTechnicalDesign: (value: string, input: 'title' | 'body') => void;
  onRemoveFile: (fileType: 'video' | 'technicalDesign') => void;
  onAddVideo: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onGoBack: () => void;
};

export default function SubmittingTechnicalValidation({
  onSubmitProject,
  githubUrl,
  urlError,
  technicalDesign,
  videoFile,
  canSubmitProject,
  onAddGithubUrl,
  onToggleTechnicalDesignModal,
  onRemoveFile,
  onAddVideo,
  onGoBack,
  onSaveTechnicalDesign,
  onChangeTechnicalDesign,
  onCloseTechnicalDesignModal,
}: SubmittingTechnicalValidationProps): JSX.Element {
  return (
    <>
      <Styles.Container>
        <Styles.Title>Submit your project</Styles.Title>

        <Styles.InputRow extraBottomSpace={!!urlError}>
          <Styles.Label htmlFor="githubUrl">GitHub Link</Styles.Label>

          <Styles.CustomInputText
            value={githubUrl}
            name="githubUrl"
            onChangeHandler={(event) => onAddGithubUrl(event.target.value)}
            errorMessage={urlError}
          />
        </Styles.InputRow>

        <Styles.InputRow>
          <span>Technical Design</span>

          <PreviewDocRow
            title={technicalDesign.title}
            onAdd={onToggleTechnicalDesignModal}
            onEdit={onToggleTechnicalDesignModal}
            onRemove={() => onRemoveFile('technicalDesign')}
          />
        </Styles.InputRow>

        <Styles.InputRow>
          <span>Video Presentation</span>

          <UploadFileRow
            inputId="video-input"
            file={videoFile}
            acceptedFileTypes="video/mp4,video/x-m4v,video/*"
            onAddFile={(event) => onAddVideo(event)}
            onRemoveFile={() => onRemoveFile('video')}
          />
        </Styles.InputRow>
      </Styles.Container>

      <Styles.ActionsBox>
        <Button onClick={onGoBack} variantStyle="outline">
          Back
        </Button>

        <Button onClick={onSubmitProject} disabled={!canSubmitProject} variantColor="yellow">
          Submit
        </Button>
      </Styles.ActionsBox>

      <TechnicalDesignModal
        onClose={onCloseTechnicalDesignModal}
        isOpen={technicalDesign.isOpen}
        title={technicalDesign.title}
        body={technicalDesign.body}
        isEditing
        isButtonDisabled={!technicalDesign.title || !technicalDesign.body}
        onConfirmHandler={onSaveTechnicalDesign}
        onChangeBody={(value: string) => onChangeTechnicalDesign(value, 'body')}
        onChangeTitle={(value: string) => onChangeTechnicalDesign(value, 'title')}
      />
    </>
  );
}
